import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {NID} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {NavigationResult, LocationChangeHistoryParam, ThunkApi} from '../interfaces'

const LOGOUT_URL = `${NID}/nidlogin.logout`

/**
 * 로그아웃 페이지로 이동
 */
const navigateToLogoutPage = createAsyncThunk<
    NavigationResult,
    (LocationChangeHistoryParam & {returnUrl?: string}) | void,
    ThunkApi
>('navigateTo/logoutPage', (args) => {
    const {historyType = 'PUSH', returnUrl} = args ?? {}
    const url = qs.stringifyUrl({
        url: LOGOUT_URL,
        query: {
            returl: returnUrl ?? location.href,
        },
    })

    changeBrowserLocation({url, type: historyType})
    // page 이동은 그 자체로 추가동작 없이 resolve 된다
    return Promise.resolve()
})

export default navigateToLogoutPage
